// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kbym","footer":"styles_footer__1o4NW"};